module.exports = __webpack_public_path__ + "static/media/connection-2.ea118c26.svg";